import { useQuery } from "@apollo/client";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "src/context";
import { GET_COLLECTIONS, GET_REVISIO_COLLECTIONS, REVISIO_HOME_LIMIT, REVISIO_ORDER_BY_POINTS, } from "src/queries/collections";
import { GET_FOLDERS } from "src/queries/folders";
import { GET_PROPOSED_COLLECTIONS } from "src/queries/propose";
import Content from "./Content";
var COLLECTIONS_LIMIT = 6;
export var FOLDERS_LIMIT = 6;
function StudentDashboardContainer() {
    var _a, _b;
    var isContentLoaded = useRef(false);
    var currentUser = useContext(UserContext);
    var t = useTranslation().t;
    var recommendations = useQuery(GET_COLLECTIONS, {
        fetchPolicy: "cache-and-network",
        variables: {
            limit: COLLECTIONS_LIMIT,
            filterBy: [
                { property: "isOfficial", where: "true" },
                { property: "isPublished", where: "true" },
                {
                    join: "recommendedInSchoolDegrees",
                    property: "id",
                    where: (_b = (_a = currentUser.schoolDegree) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "",
                },
            ],
        },
    });
    var proposedCollections = useQuery(GET_PROPOSED_COLLECTIONS, {
        fetchPolicy: "cache-and-network",
        pollInterval: 10000,
    });
    var subscriptions = useQuery(GET_FOLDERS, {
        fetchPolicy: "network-only",
        variables: {
            limit: FOLDERS_LIMIT,
            filterBy: [
                { join: "linkUsers", property: "user", where: currentUser.id },
            ],
        },
    });
    var revisioCollections = useQuery(GET_REVISIO_COLLECTIONS, {
        fetchPolicy: "cache-and-network",
        variables: {
            page: 1,
            limit: REVISIO_HOME_LIMIT,
            orderBy: REVISIO_ORDER_BY_POINTS,
        },
        pollInterval: 10000,
    });
    var loading = recommendations.loading ||
        proposedCollections.loading ||
        subscriptions.loading ||
        revisioCollections.loading;
    var error = recommendations.error ||
        proposedCollections.error ||
        subscriptions.error ||
        revisioCollections.error;
    if (loading && !isContentLoaded.current)
        return React.createElement("div", null);
    if (error)
        return React.createElement("p", null, t("error"));
    isContentLoaded.current = true;
    return (React.createElement(Content, { dataRecommendations: recommendations.data, dataSubscriptions: subscriptions.data, dataProposedCollections: proposedCollections.data, dataRevisio: revisioCollections.data }));
}
export default StudentDashboardContainer;
